import React from "react";
import { Loader2 } from "lucide-react";

// Mismo grid visual que ya usaba AppointmentConfirm para reprogramar — se
// extrae aquí para que la página pública de auto-reserva (que agenda una cita
// nueva, no una existente) lo reutilice sin duplicar el JSX.

const formatDayHeading = (dateString, timeZone) =>
  new Intl.DateTimeFormat("es-ES", {
    timeZone,
    weekday: "long",
    day: "numeric",
    month: "long",
  }).format(new Date(`${dateString}T12:00:00Z`));

const AppointmentSlotGrid = ({
  loading,
  days,
  timeZone,
  onPickSlot,
  disabled,
  emptyMessage = "No quedan horarios libres en las próximas semanas. Intenta más tarde.",
}) => {
  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <Loader2 className="w-6 h-6 animate-spin text-indigo-500" />
      </div>
    );
  }

  if (!days || days.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-slate-500 dark:text-slate-400">
        {emptyMessage}
      </p>
    );
  }

  return (
    <div className="space-y-4">
      {days.map((day) => (
        <div key={day.date}>
          <p className="mb-2 text-[11px] font-bold text-slate-400 uppercase tracking-wider capitalize">
            {formatDayHeading(day.date, timeZone)}
          </p>
          <div className="grid grid-cols-3 gap-2">
            {day.slots.map((slot) => (
              <button
                key={slot.start}
                onClick={() => onPickSlot(slot.start)}
                disabled={disabled}
                className="py-2 text-sm font-medium text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700 rounded-lg hover:border-indigo-500 hover:text-indigo-600 disabled:opacity-40 transition-colors"
              >
                {slot.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppointmentSlotGrid;
